var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.showMask)?_c('view',{staticClass:"img-box",on:{"click":_vm.closeMask}},[_c('image',{staticClass:"guide-img",attrs:{"src":"/static/guide.png","mode":"widthFix"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }